import React from 'react'

import './footer_menu.scss'

export default () => {
  return (
    <div className="footer-menu">
      <ul className="mb-5">
        <li>
          <a href="/community">
            Community
          </a>
        </li>
        <li>
          <a href="/resources">
            Resources
          </a>
        </li>
        <li>
          <a href="/about">
            About
          </a>
        </li>
      </ul>

      <ul>
        <li>
          <a href="/contact">
            Contact
          </a>
        </li>
        <li>
          <a href="/resources/credit-application">
            Credit Application
          </a>
        </li>
      </ul>
    </div>
  )
}
